class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();

      document.querySelectorAll('[data-modal]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          setTimeout(() => {
            this.open(el);
          }, 5);
        });
      });

      document.querySelectorAll('[data-close-modal]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
  
          this.close();
  
        });
      });


    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
  
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();

        if (window.innerWidth < 1024) {
          window.location.href = '/cart';
        } else {
          this.open(cartLink);
        }

      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();

          if (window.innerWidth < 1024) {
            window.location.href = '/cart';
          } else {
            this.open(cartLink);
          }

        }
      });
    }
  
    open(triggeredBy) {
      // Emit the analytics event only when the drawer transitions from closed to open.
      const wasOpen = this.contentsquareDrawerOpen || this.classList.contains('active');
      this.contentsquareDrawerOpen = true;

      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
        if (!wasOpen) {
          this.dispatchEvent(new CustomEvent('cart-drawer:opened', { bubbles: true }));
        }
      });
  
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      const modals = document.querySelectorAll('.drawer-modal');
      let anyHasShow = false;
    
      modals.forEach(modal => {
        if (modal.classList.contains('show')) {
          anyHasShow = true;
        }
      });
    
      if (anyHasShow && !document.body.classList.contains('template--cart')) {
        modals.forEach(modal => modal.classList.remove('show'));
      } else {
        // Emit the close event only when the Cart Drawer itself was open.
        const wasOpen = this.contentsquareDrawerOpen || this.classList.contains('active');

        this.classList.remove('active');
        this.contentsquareDrawerOpen = false;
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');

        setTimeout(() => {
          modals.forEach(modal => modal.classList.remove('show'));
        }, 800);

        if (wasOpen) {
          this.dispatchEvent(new CustomEvent('cart-drawer:closed', { bubbles: true }));
        }
      }
    }    
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
  
        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
  
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        if (!document.body.classList.contains('template--cart')) {
          this.open();
        }
      });
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '.drawer-js',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer-js',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);
